import React, { useState } from 'react';
import { getAuth } from 'firebase/auth';
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from 'firebase/storage';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase.config';
import { toast } from 'react-toastify';
import NavBox from '../components/NavBox';
import ProgressBar from '../components/ProgressBar';
import UserBox from '../components/UserBox';

function AddBook() {
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [formData, setFormData] = useState({
    title: '',
    author: '',
    isbn: '',
    language: '',
    pages: '',
    images: {},
  });

  const { title, author, isbn, language, pages, images } = formData;

  const auth = getAuth();

  const onChange = e => {
    if (!e.target.files) {
      setFormData(prevState => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }

    if (e.target.files) {
      setFormData(prevState => ({
        ...prevState,
        images: e.target.files,
      }));
    }
  };

  const onSubmit = async e => {
    e.preventDefault();

    // Store images to database
    const storeImage = async img => {
      return new Promise((resolve, reject) => {
        const storage = getStorage();
        const fileName = `${auth.currentUser.uid}-${img[0].name}`;

        const storageRef = ref(storage, 'images/' + fileName);
        const imageBlob = new Blob(img);
        const uploadTask = uploadBytesResumable(storageRef, imageBlob);

        uploadTask.on(
          'state_changed',
          snapshot => {
            const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setLoadingProgress(progress);
          },
          error => {
            reject(error);
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref).then(downloadURL => {
              resolve(downloadURL);
            });
          }
        );
      });
    };

    const imgUrls = await storeImage(images).catch(() => {
      toast.error('Image not uploaded');
    });

    // Saving book details to database
    const formDataCopy = {
      ...formData,
      imgUrls,
      userRef: auth.currentUser.uid,
      timestamp: serverTimestamp(),
    };
    delete formDataCopy.images;

    await addDoc(collection(db, 'books'), formDataCopy);

    toast.success('Book saved');

    setFormData({
      author: '',
      title: '',
      isbn: '',
      language: '',
      pages: '',
      images: {},
    });
  };

  return (
    <>
      <UserBox />

      <form className="form" onSubmit={onSubmit}>
        <div className="form__control u-margin-bottom-m">
          {!loadingProgress ? (
            <></>
          ) : (
            <ProgressBar percent={loadingProgress.toFixed()} />
          )}
        </div>

        <div className="form__control u-margin-bottom-m">
          <h4 className="heading-4">Author</h4>

          <input
            type="text"
            name="author"
            id="author"
            className="form__input"
            value={author}
            required
            onChange={onChange}
          />
        </div>

        <div className="form__control u-margin-bottom-m">
          <h4 className="heading-4">Title</h4>

          <input
            type="text"
            name="title"
            id="title"
            className="form__input"
            value={title}
            required
            onChange={onChange}
          />
        </div>

        <div className="form__control u-margin-bottom-m">
          <h4 className="heading-4">ISBN</h4>

          <input
            type="number"
            name="isbn"
            id="isbn"
            className="form__input"
            value={isbn}
            required
            onChange={onChange}
          />
        </div>

        <div className="form__control u-margin-bottom-m">
          <h4 className="heading-4">Language</h4>

          <input
            type="text"
            name="language"
            id="language"
            className="form__input"
            value={language}
            required
            onChange={onChange}
          />
        </div>

        <div className="form__control u-margin-bottom-m">
          <h4 className="heading-4">Number of Pages</h4>

          <input
            type="number"
            name="pages"
            id="pages"
            className="form__input"
            value={pages}
            required
            onChange={onChange}
          />
        </div>

        <div className="form__control u-margin-bottom-xl">
          <h4 className="heading-4">
            Book Cover {''}
            <span className="paragraph-xs paragraph-bold">
              [max. size: 2MB (.jpg, .jpeg, .png)]
            </span>
          </h4>

          <input
            type="file"
            name="image"
            id="image"
            className="btn__file-upload"
            size="2097152"
            max="1"
            accept=".jpg, .jpeg, .png"
            required
            onChange={onChange}
          />
        </div>

        <div className="form__control u-margin-bottom-m">
          <button type="submit" className="btn btn__form">
            Add Book
          </button>
        </div>

        <NavBox />
      </form>
    </>
  );
}

export default AddBook;
